import { SearchFacetRefinementSelect, SearchFacets, SearchResultsInfinite } from '@uncinc/react-searchkit';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import LinkList from '../../../LinkList';
import { LeafletMapProps, SearchResult } from '../../types';
import { SCREEN_NORMAL } from '../../../../config/constants';
import SearchFilterDialog from '../../../Search/FilterDialog';

import './style.scss';

const Sidebar: React.FC<Pick<LeafletMapProps, 'mapRef'>> = React.memo((props) => {
  const { mapRef } = props;
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  return (
    <div className="ProjectMap__sidebar">
      {width < SCREEN_NORMAL ? (
        <SearchFilterDialog
          title={t('components.project_map.sidebar_title')}
          openButtonProps={{
            iconPosition: 'left',
          }}
        >
          {({ closeDialog }) => (
            <>
              <SearchFacets>
                <div className="mb-2">
                  <SearchFacetRefinementSelect
                    attribute="project_type"
                    placeholder={t('components.project_map.filters.project_type_placeholder')}
                  />
                </div>
                <SearchFacetRefinementSelect
                  attribute="project_status"
                  placeholder={t('components.project_map.filters.project_status_placeholder')}
                />
              </SearchFacets>
              <LinkList>
                <SearchResultsInfinite
                  renderItem={(hit) => {
                    const searchHit = hit as SearchResult;
                    return (
                      <LinkList.SecondaryItem
                        title={searchHit.title[0]}
                        link={searchHit.url[0]}
                        onClick={(e) => {
                          e.preventDefault();
                          closeDialog();
                          mapRef.current?.eachLayer((layer) => {
                            // @ts-ignore
                            if (searchHit.objectID === layer.options.id) {
                              layer.fire('click');
                            }
                          });
                        }}
                      />
                    );
                  }}
                />
              </LinkList>
            </>
          )}
        </SearchFilterDialog>
      ) : (
        <>
          <h3>{t('components.project_map.sidebar_title')}</h3>
          <SearchFacets>
            <div className="mb-2">
              <SearchFacetRefinementSelect
                attribute="project_type"
                placeholder={t('components.project_map.filters.project_type_placeholder')}
              />
            </div>
            <SearchFacetRefinementSelect
              attribute="project_status"
              placeholder={t('components.project_map.filters.project_status_placeholder')}
            />
          </SearchFacets>
          <LinkList>
            <SearchResultsInfinite
              renderItem={(hit) => {
                const searchHit = hit as SearchResult;
                return (
                  <LinkList.SecondaryItem
                    title={searchHit.title[0]}
                    link={searchHit.url[0]}
                    onClick={(e) => {
                      e.preventDefault();
                      mapRef.current?.eachLayer((layer) => {
                        // @ts-ignore
                        if (searchHit.objectID === layer.options.id) {
                          layer.fire('click');
                        }
                      });
                    }}
                  />
                );
              }}
            />
          </LinkList>
        </>
      )}
    </div>
  );
});

export default Sidebar;
